import { jsx as _jsx } from "react/jsx-runtime";

/* hs-eslint ignored failing-rules */

/* eslint-disable @typescript-eslint/no-floating-promises */
import PropTypes from 'prop-types';
import { useState } from 'react';
import { track } from 'ui-addon-upgrades/_core/common/eventTracking/tracker';
import { upgradeDataPropsInterface } from '../common/data/upgradeData/interfaces/upgradeDataPropsInterface';
import { loadAndOpenSalesChat } from '../utils/loadAndOpenSalesChat';
import { submitPql } from '../pql/submitPql';
import { ReducedOptionsModal } from './ReducedOptionsModal';
import { getUpgradeDataTrackingProperties } from 'ui-addon-upgrades/ums/utils';
import { trackPricingPagePql } from '../utils/metricUtils';

const UnassignableModal = ({
  handleIframeSizeChange,
  onClose,
  upgradeData,
  hideBackground,
  ModalComponent,
  modalRoot,
  isUpgradePoint
}) => {
  const [hasTracked, setHasTracked] = useState(false);

  const onModalView = () => {
    if (!hasTracked) {
      track('communicationMethodsInteraction', Object.assign({
        action: 'viewed unassignable modal'
      }, getUpgradeDataTrackingProperties(upgradeData, isUpgradePoint)));
      submitPql(Object.assign({}, upgradeData, {
        isRetail: false,
        isAssignable: false
      }));
      trackPricingPagePql(upgradeData.app);
      setHasTracked(true);
    }
  };

  const handleClickChatTrack = () => {
    track('communicationMethodsInteraction', Object.assign({
      action: 'clicked unassignable chat button'
    }, getUpgradeDataTrackingProperties(upgradeData, isUpgradePoint)));
    loadAndOpenSalesChat({
      upgradeData,
      isRetail: false
    });
    onClose();
  };

  const handleClickCallTrack = () => {
    track('communicationMethodsInteraction', Object.assign({
      action: 'clicked unassignable phone button'
    }, getUpgradeDataTrackingProperties(upgradeData, isUpgradePoint)));
  };

  return /*#__PURE__*/_jsx(ReducedOptionsModal, {
    onModalView: onModalView,
    onClickChat: handleClickChatTrack,
    onClickCall: handleClickCallTrack,
    modalRoot: modalRoot,
    onClose: () => onClose(),
    isRetail: false,
    upgradeData: upgradeData,
    handleIframeSizeChange: handleIframeSizeChange,
    hideBackground: hideBackground,
    ModalComponent: ModalComponent,
    isUpgradePoint: isUpgradePoint
  });
};

UnassignableModal.propTypes = Object.assign({
  handleIframeSizeChange: PropTypes.func,
  hideBackground: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  ModalComponent: PropTypes.elementType,
  modalRoot: PropTypes.object
}, upgradeDataPropsInterface);
export default UnassignableModal;